import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Zero To Cloud | The Best AWS Learning Courses",
  description = "Zero to Cloud is the #1 AWS Cloud Learning Platform, with certification preparation courses, hands-on projects, and interview mastery resources. Start learning now!",
  keywords = "AWS certification, AWS cloud computing, AWS training, AWS cloud architect, DevOps, AWS cloud engineer, AWS projects, AWS certification prep",
  url = "https://www.zerotocloud.co",
  image = "/instructor-thumbnail.png",
  type = "website",
  author = "Lucy Wang",
  siteName = "Zero To Cloud",
  twitterCard = "summary_large_image",
  locale = "en_US"
}) => {
  const fullImageUrl = image.startsWith('http') ? image : `${url}${image}`;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={url} />
      
      {/* Open Graph Tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:image:alt" content={title} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={locale} />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:image:alt" content={title} />
      
      {/* Additional SEO Meta Tags */}
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      
      {/* Structured Data - Organization */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": siteName,
          "url": "https://www.zerotocloud.co",
          "logo": "https://www.zerotocloud.co/instructor-thumbnail.png",
          "description": description,
          "founder": {
            "@type": "Person",
            "name": author
          },
          "sameAs": [
            "https://www.youtube.com/channel/UCExample"
          ]
        })}
      </script>
      
      {/* Structured Data - Educational Organization */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "EducationalOrganization",
          "name": siteName,
          "url": "https://www.zerotocloud.co",
          "description": "Online AWS cloud computing education platform offering AWS certification training and hands-on projects",
          "educationalCredentialAwarded": "Cloud Computing Certification",
          "hasCredential": {
            "@type": "EducationalOccupationalCredential",
            "name": "Cloud Computing Professional Certificate"
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEO;